import Add from "@material-ui/icons/Add";
import React from "react";
import Fade from "react-reveal/Fade";
import TariffForm from "../../components/Tariff/TariffForm/TariffForm";
import Button from "../../components/UI/Button/Button";
import Input from "../../components/UI/Input/Input";
import Modal from "../../components/UI/Modal/Modal";
import Search from "../../components/UI/Search/Search";
import Spinner from "../../components/UI/Spinner/Spinner";
import Table from "../../components/UI/Table/Table";
import FetchData from "../../shared/fetchData";
import { updateObject } from "../../shared/utility";

const Tariffs = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [rerender, setRerender] = React.useState(false);
  const [pageSize, setPageSize] = React.useState(10);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageCount, setPageCount] = React.useState(0);
  const [tableData, setTableData] = React.useState([]);
  const [permission, setPermission] = React.useState(
    window.localStorage.getItem("permission")
  );
  const [tariffs, setTariffs] = React.useState([]);
  const [newTariffPage, setNewTariffPage] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [tariff, setTariff] = React.useState("");
  const [tariffId, setTariffId] = React.useState("");
  const [searchParams, setSearchParams] = React.useState({
    description: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        required: true,
      },
      errorMessage: "",
      valid: true,
      value: "",
    },
  });

  const childRef = React.useRef();
  const stateRef = React.useRef();

  React.useEffect(() => {
    setPageIndex(0);
    setPageSize(10);
    setPageCount(0);
  }, []);

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(searchParams, {
      [controlName]: updateObject(searchParams[controlName], {
        value: event.target.value,
      }),
    });
    setSearchParams(updatedControls);
  };
  const getData = (pagination, isRefresh) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setLoading(true);
    var raw =
      !!isRefresh && isRefresh
        ? JSON.stringify({
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          })
        : JSON.stringify({
            tariff: {
              description: searchParams.description.value,
            },
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          });
    var url = "management/api/v1/tariffs/getTariffs";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          let newList = [];
          for (let i = 0; i < pagination.pageIndex * pagination.pageSize; i++) {
            newList.push([]);
          }
          newList = newList.concat(result.tariffs);
          pushData(newList);
          setTariffs(newList);
          setPageCount(result.count);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => setLoading(false));
  };
  const pushData = (data) => {
    const rows = [];
    const headers = [
      {
        accessorKey: "description",
        header: "شرح",
        align: "center",
      },
      {
        accessorKey: "cancelPenaltyPercent",
        header: "درصد کسر مبلغ",
        align: "center",
      },
      {
        accessorKey: "fromDate",
        header: "از تاریخ",
        align: "center",
      },
      {
        accessorKey: "toDate",
        header: "تا تاریخ",
        align: "center",
      },
      {
        accessorKey: "firstMilePrice",
        header: "هزینه جمع آوری",
        align: "center",
      },
      {
        accessorKey: "lastMilePrice",
        header: "هزینه تخلیه",
        align: "center",
      },
      {
        accessorKey: "returnPassValue",
        header: "هزینه رمز مرجوعی",
        align: "center",
      },
      {
        accessorKey: "finalize",
        header: "وضعیت رکورد",
        align: "center",
      },
      {
        accessorKey: "isActive",
        header: "وضعیت",
        align: "center",
      },
    ];
    const buttons = [];
    buttons.push({ id: 1, text: "ویرایش", clicked: editTariff });
    if (permission.includes != null && permission.includes("TARIFF_WRITE")) {
      buttons.push({ id: 2, text: "نهایی کردن", clicked: finalizeTariff });
      buttons.push({ id: 3, text: "تغییر وضعیت", clicked: tariffChangeState });
    }
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    data.map((d) => {
      rows.push({
        id: d.id,
        description: d.description,
        cancelPenaltyPercent: d.cancelPenaltyPercent,
        fromDate: d.fromDate,
        toDate: d.toDate,
        firstMilePrice: d.firstMilePrice?.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        lastMilePrice: d.lastMilePrice?.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        returnPassValue: d.returnPassValue?.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        ),
        finalize:
          d.finalize != null && d.finalize == "1" ? "نهایی است" : "نهایی نیست",
        isActive:
          d.isActive != null && d.isActive == "1" ? "فعال است" : "فعال نیست",
      });
    });
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    setRerender(!rerender);
  };

  const search = (event) => {
    getData({ pageIndex: pageIndex, pageSize: pageSize });
  };

  const refresh = (event) => {
    const srch = searchParams;
    for (let key in srch) {
      srch[key].value = "";
    }
    setSearchParams(srch);
    getData({ pageIndex: pageIndex, pageSize: pageSize }, true);
  };

  const toggleNewLockerForm = (event, value) => {
    if (value == false) {
      search();
    }
    setNewTariffPage(value);
  };

  const addNewTariff = (event, id) => {
    setTariff("");
    setEdit(false);
    toggleNewLockerForm(event, true);
  };

  const editTariff = (id, data) => {
    const lckrTp = data.filter((l) => l.id == id);
    if (lckrTp != null && lckrTp.length != 0) {
      setTariff(lckrTp[0]);
      setEdit(true);
      toggleNewLockerForm(null, true);
    }
  };

  const finalizeTariff = (id) => {
    setTariffId(id);
    childRef.current.openModal();
  };
  const finalizeTariffSubmit = (event) => {
    var raw = JSON.stringify({
      tariff: {
        id: tariffId,
      },
      version: "mtpx001",
    });
    var url = "management/api/v1/tariffs/finalizeTariff";
    setLoading(true);
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          childRef.current.closeModal();
          search();
        }
      })
      .catch((error) => setLoading(false));
  };

  const tariffChangeState = (id) => {
    setTariffId(id);
    stateRef.current.openModal();
  };
  const tariffChangeStateSubmit = (event, id) => {
    var raw = JSON.stringify({
      tariff: {
        id: tariffId,
      },
      version: "mtpx001",
    });
    var url = "management/api/v1/tariffs/changeTariffState";
    setLoading(true);
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          stateRef.current.closeModal();
          search();
        }
      })
      .catch((error) => setLoading(false));
  };

  const afterCloseModal = (event) => {};
  const closeModal = (event) => {
    childRef.current.closeModal();
  };
  const closeStateModal = (event) => {
    stateRef.current.closeModal();
  };

  const formElementsArray = [];
  for (let key in searchParams) {
    formElementsArray.push({
      id: key,
      config: searchParams[key],
    });
  }

  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        search={true}
        col="3 mt-2"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });
  form = (
    <div>
      <div className="row pl-4" dir="ltr" style={{ height: "0px" }}>
        <Button btnType="Refresh" clicked={refresh}></Button>
      </div>
      <div className="row mt-4">{form}</div>
      <div className="row text-left" dir="ltr">
        <div className="col-2">
          <Button btnType="search-btn" clicked={search}>
            جستجو
          </Button>
        </div>
      </div>
    </div>
  );

  const modalContent = (
    <div>
      <div className="row justify-content-center">
        آیا از نهایی کردن مطمئن هستید؟
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-6">
          <Button btnType="Success" clicked={closeModal}>
            خیر
          </Button>
        </div>
        <div className="col-6">
          <Button btnType="Success" clicked={finalizeTariffSubmit}>
            بله
          </Button>
        </div>
      </div>
    </div>
  );
  const stateContent = (
    <div>
      <div className="row justify-content-center">
        آیا ازتغییر وضعیت مطمئن هستید؟
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-6">
          <Button btnType="Success" clicked={closeStateModal}>
            خیر
          </Button>
        </div>
        <div className="col-6">
          <Button btnType="Success" clicked={tariffChangeStateSubmit}>
            بله
          </Button>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      {loading ? <Spinner /> : ""}
      {!newTariffPage ? (
        <Fade duration={200} left cascade>
          <div>
            <Search class="orders-search" form={form} />
            {permission.includes != null &&
            permission.includes("TARIFF_WRITE") ? (
              <div className="row justify-content-center mt-3 ml-3">
                <div className="UserGeneralBtn mb-2">
                  <div onClick={(event) => addNewTariff(event)} className="Add">
                    <Add className="UserIcon" />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {rerender ? (
              // <Spinner />
              <Table
                hasDetails={false}
                data={tariffs}
                pageSize={pageSize}
                pageIndex={pageIndex}
                getData={getData}
                list={tableData}
                rowCount={pageCount}
                columnSize={170}
                loading={loading}
              />
            ) : (
              <Table
                hasDetails={false}
                data={tariffs}
                pageSize={pageSize}
                pageIndex={pageIndex}
                getData={getData}
                list={tableData}
                rowCount={pageCount}
                columnSize={170}
                loading={loading}
              />
            )}
          </div>
        </Fade>
      ) : (
        <TariffForm
          edit={edit}
          tariff={edit ? tariff : ""}
          toggleNewLockerForm={toggleNewLockerForm}
        />
      )}
      <Modal
        content={modalContent}
        ref={childRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
      <Modal
        content={stateContent}
        ref={stateRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
    </div>
  );
};

export default Tariffs;
